export default (array, el) => {
  return array.some( e => e === el) ? array.filter( e => e !== el) : [...array, el];
}
